import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { message, Modal } from 'antd';

export class CouponItem extends Component {

  state = {
    visibleModel: false
  }

  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  collarCoupon(ID) {
    let actionsApi = this.props.actions;
    actionsApi.fetchStudentGetCoupon({ ID }).then(res => {
      if (res.SuccessResponse && res.Data) {
        actionsApi.fetchStudentShowCouponList();
      } else {
        message.error(res.Message);
      }
    });
  }

  openModel(ID) {
    this.props.actions.fetchGetCouponCourseList({ ID });
    this.setState({
      visibleModel: true
    })
  }
  handleCancel() {
    this.setState({
      visibleModel: false
    })
  }

  render() {
    let { RangeType, Title, FacePrice, Content, ID, IsGet } = this.props;
    let { visibleModel } = this.state;
    let { fetchGetCouponCourseListSuccess } = this.props.course;
    return (
      <div className="course-coupon-item">
        <div className='item_price'>
          <div className='price_box'>
            <span>￥</span>
            <span className='price_number'>{FacePrice}</span>
          </div>
          <div style={{ fontSize: 14 }}>代金券</div>
        </div>
        <div className='price_section'>
          <div className='coupon_name'>{Title}</div>
          {RangeType === 0 ?
            <div className='coupon_intro'>适用范围：全网通用</div>
            :
            <div className='coupon_intro' style={{ cursor: 'pointer' }} onClick={this.openModel.bind(this, ID)}>适用范围：部分可用 点击查看>></div>
          }
          <div className='coupon_intro'><span style={{ display: 'inline-block', width: 70 }}>使用说明：</span>  <span style={{ flex: 1, lineHeight: '16px' }} dangerouslySetInnerHTML={{ __html: Content }}></span></div>
        </div>
        {IsGet === 1 ? <div className='coupon_collar_use collar_pay'>
          <div className='coupon_btn_title'>已领取</div>
        </div> : <div className='coupon_collar_use collar' onClick={this.collarCoupon.bind(this, ID)}>
            <div className='coupon_btn_title'>立即领券</div>
          </div>}
        {fetchGetCouponCourseListSuccess &&
          <Modal
            title="可用范围"
            visible={visibleModel}
            onCancel={this.handleCancel.bind(this)}
            footer={[]}
            bodyStyle={{ color: '#999', lineHeight: 1 }}
          >
            <div className='modal_box'><p style={{ marginBottom: 14 }}><span>券&emsp;&emsp;名：</span>{fetchGetCouponCourseListSuccess.Coupon.Title}</p>
              <p style={{ display: 'flex', flexDirection: 'row', marginBottom: 14 }}><span style={{ width: 70 }}>使用规则：</span><span style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: fetchGetCouponCourseListSuccess.Coupon.Content }}></span></p>
              <p style={{ marginBottom: 14 }}><span>使用期限：</span>{fetchGetCouponCourseListSuccess.Coupon.DateType === 1 ? (fetchGetCouponCourseListSuccess.Coupon.StartTime.replace('T', ' ') + ' - ' + fetchGetCouponCourseListSuccess.Coupon.EndTime.replace('T', ' ')) : fetchGetCouponCourseListSuccess.Coupon.DateCount + '天'}</p>
              <p style={{ marginBottom: 14, lineHeight: '18px', display: 'flex', flexDirection: 'row' }}><span style={{ width: 70 }}>使用范围：</span><span style={{ flex: 1 }}>{fetchGetCouponCourseListSuccess.CourseNameList.join('，')}</span></p></div>
          </Modal>}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouponItem);



// WEBPACK FOOTER //
// ./src/features/course/CouponItem.js